import { useCallback, useState } from 'react'

export const useSearch = (searchCallback: (value: string) => void) => {
  const [ lastSearchTimeout, setLastSearchTimeout ] = useState<number | NodeJS.Timeout>()

  return useCallback((value: string) => {
    if (lastSearchTimeout) {
      clearTimeout(lastSearchTimeout)
    }

    const timeout = setTimeout(() => {
      searchCallback?.(value)
    }, 500)

    setLastSearchTimeout(timeout)
  }, [ searchCallback, lastSearchTimeout ])
}
